export default __webpack_public_path__ + "static/media/ico_ok.f45ea1f5.svg";